<template>
  <main class="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <p class="text-base font-semibold text-gray-darker">404</p>
      <h1
        class="mt-4 text-3xl font-bold tracking-tight text-gray-darker sm:text-5xl"
      >
        Stranica nije pronađena
      </h1>
      <p class="mt-6 text-base leading-7 text-gray">
        Izvinite, nismo mogli pronaći stranicu koju tražite.
      </p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <RouterLink
          to="/mne/chats/new"
          class="rounded-[20px] bg-gray-light px-3.5 py-2.5 text-sm font-semibold text-gray-darker shadow-sm hover:bg-gray-lighter focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Nazad na početnu
        </RouterLink>
      </div>
    </div>
  </main>
</template>
